import script from "./amendment-type-icon.vue?vue&type=script&setup=true&lang=ts"
export * from "./amendment-type-icon.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__